import { USER_FETCH_REQUESTED } from './types';

export function getSignedInUser(client, onFinish, onError) {
	return { type: USER_FETCH_REQUESTED, client, onFinish, onError };
}
